<template>
  <div id="login-message" v-if="serverErrors.length > 0">
    <div id="error-message-wrapper">
      <div class="mb-4">
        <i class="fas fa-exclamation-triangle fa-6x"></i>
      </div>
      <div v-for="(error, index) in serverErrors" :key="index">
        {{ error.message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailConfirm",
  data() {
    return {
      serverErrors: [],
      user: {
        email: "",
        password: ""
      }
    };
  },
  mounted() {
    if (this.$route.query.kod) {
      this.checkRegistrationCode(this.$route.query.kod);
    } else {
      this.serverErrors.push({ message: this.$t("verification_code") });
    }
  },
  methods: {
    async checkRegistrationCode(code) {
      try {
        await this.$http.post("doctors/verify-email", {
          email_verification_code: code
        });
        this.$store.commit("setAuthenticated", true);
        this.$router.push({ name: "kalkulator" });
      } catch (error) {
        if (error.status >= 500) {
          // eslint-disable-next-line no-console
          console.error("Server error");
        } else {
          this.serverErrors = error.data.errors;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#error-message-wrapper {
  padding: 1rem;
  max-width: 20rem;
  background-color: white;
  margin: auto;
  margin-top: 12rem;
  text-align: center;
  font-size: 1.2rem;
  color: red;
}
</style>
